<div class="header-menu">
    <div class="flex-row start-center gap-16">
        <ui-header-with-breadcrumbs [selectBreadcrumbs]="breadcrumbsSig()"></ui-header-with-breadcrumbs>
    </div>

    <div class="flex-row start-center gap-8">
        @if(graphModeSig() === graphModes.Preview) {
        @if(invalidNodesSig()?.length) {
        <div [matMenuTriggerFor]="inavlidNodesmenu"
             class="c-p flex-row start-center gap-8 errors-select">
            <span class="ui-icon-status-offline"></span>
            @if(invalidNodesSig().length > 1) {
            {{'FLOW_CHART.INVALID_NODES_TRIGGER'|translate : {number: invalidNodesSig().length} }}
            } @else {
            {{'FLOW_CHART.INVALID_NODE_TRIGGER'|translate : {number: invalidNodesSig().length} }}
            }
        </div>
        <mat-menu #inavlidNodesmenu="matMenu"
                  class="menu-no-padding">
            @for(node of invalidNodesSig(); track node.id) {
            <div mat-menu-item
                 class="c-p"
                 (click)="openNodeEditModal(node,true)">{{node.name}}</div>
            }
        </mat-menu>
        }
        }
        @if(selectGraphSig()?.published) {
        <ui-button type="default"
                   iconClass="ui-icon-list-view-2 mr-8"
                   (clickAction)="openRunList()">{{'FLOW_CHART.RUN_LIST_TABLE.OPEN_RUN_LIST'|translate}}
        </ui-button>
        }

        <div class="menu-separator"></div>

        @if(graphModeSig() === graphModes.Preview) {
        <ui-button type="secondary"
                   (clickAction)="publish()">{{'FLOW_CHART.PUBLISH'|translate}}
        </ui-button>
        }
        <div class="view-menu flex-row gap-8">
            <div (click)="changeGraphMode(graphModes.Preview)"
                 [class.selected]="graphModeSig() === graphModes.Preview">{{ 'FLOW_CHART.PREV_MODE'|translate }}
            </div>
            <div (click)="changeGraphMode(graphModes.Publish)"
                 [class.disabled]="!selectGraphSig()?.published"
                 [class.selected]="graphModeSig() === graphModes.Publish">{{ 'FLOW_CHART.PUBLISH_MODE'|translate }}
            </div>
        </div>

        <div class="menu-separator"></div>

        <span class="ui-icon-more-menu ui-icon-button no-border"
              [matMenuTriggerFor]="menu">
        </span>
    </div>
</div>

<mat-drawer-container class="sidenav-container">
    <mat-drawer #drawer
                class="sidenav"
                mode="side"
                position="end">
        <div class="header flex-row space-between-center gap-30">
            @switch (sideNavModeSig()) {
            @case (sideNavModes.TriggerMenu) {
            <div class="header-text">{{'FLOW_CHART.TRIGGER_MENU_HEADER'|translate}}</div>
            <span class="ui-icon-close c-p"
                  (click)="closeDrawerAndClearSelection()">
            </span>
            }
            @case (sideNavModes.ActionMenu) {
            <div class="header-text">{{'FLOW_CHART.ACTION_MENU_HEADER'|translate}}</div>
            <span class="ui-icon-close c-p"
                  (click)="closeDrawerAndResetMenu()">
            </span>
            }
            }
        </div>
        <hr>

        <div class="content">
            @switch (sideNavModeSig()) {
            @case (sideNavModes.TriggerMenu) {
            <div class="sub-header uppercase">{{'FLOW_CHART.TRIGGERS'|translate}}</div>

            <div class="mt-15 flex-col gap-10">
                @for (trigger of config().triggers; track trigger) {
                <div class="sidenav-node flex-row start-center gap-12 c-p"
                     (click)="addTriggerNode(trigger)">
                    <span [class]="trigger.icon"></span>
                    <div>
                        <div class="name">{{trigger.name}}</div>
                        <div class="description">{{trigger.description}}</div>
                    </div>
                </div>
                }
            </div>
            }
            @case (sideNavModes.ActionMenu) {
            <div class="sub-header uppercase">{{'FLOW_CHART.ACTIONS'|translate}}</div>

            <div class="mt-15 flex-col gap-16">
                <ui-search (onInput)="searchNodesSig.set($event)"
                           [placeholder]="'FLOW_CHART.SEARCH_NODES' | translate"
                           [searchQuery]="searchNodesSig()">
                </ui-search>

                @if(searchNodesSig()) {
                <div class="flex-col gap-10">
                    @for (action of filteredActionsSig(); track action) {

                    <div class="sidenav-node flex-row start-center gap-12 c-p"
                         (click)="addActionNode(action)">
                        <span [class]="action.icon"></span>
                        <div>
                            <div class="name">{{action.name}}</div>
                            <div class="description">{{action.description}}</div>
                        </div>
                    </div>
                    }
                </div>
                }@else {
                @for(actionGroup of workflowActionGroups; track actionGroup) {
                <div class="flex-col gap-10">
                    <mat-accordion class="workflow-action-menu-accordion level-2 w-100"
                                   [togglePosition]="'before'">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{workflowActionGroupsMap[actionGroup]|translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            @let actions = configActionsMapByGroupSig()[actionGroup];

                            <div class="flex-col gap-10">
                                @for (action of actions; track action) {

                                <div class="sidenav-node flex-row start-center gap-12 c-p"
                                     (click)="addActionNode(action)">
                                    <span [class]="action.icon"></span>
                                    <div>
                                        <div class="name">{{action.name}}</div>
                                        <div class="description">{{action.description}}</div>
                                    </div>
                                </div>
                                }
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                }
                }
            </div>
            }
            }
        </div>
    </mat-drawer>

    @if(!selectIsLoadingSig()){
    <div class="sidenav-content">
        @if (graphModeSig() === graphModes.Preview && !drawer.opened) {
        <span class="ui-icon-plus c-p add-node-btn"
              (click)="drawer.open()">
        </span>
        }

        @if(graphModeSig() === graphModes.Preview) {
        <span class="ui-icon-file ui-icon-button add-sticker-btn"
              (click)="addSticker()">
        </span>
        }

        <div class="toolbar flex-row start-center gap-16">
            <span class="ui-icon-camera-control-zoomin ui-icon-button"
                  (click)="onZoomOut()">
            </span>
            <span class="ui-icon-camera-control-zoomout ui-icon-button"
                  (click)="onZoomIn()">
            </span>
            <span class="ui-icon-fullscreen-2 ui-icon-button"
                  (click)="onFitToScreen()">
            </span>
        </div>

        <f-flow fDraggable
                (fLoaded)="loaded()"
                (fSelectionChange)="selectionChanged($event)"
                (fCreateConnection)="onCreateConnection($event)">
            <f-background>
                <f-rect-pattern />
            </f-background>

            <f-canvas fZoom>
                @if(graphModeSig() === graphModes.Preview) {
                <f-connection-for-create fBehavior="floating"></f-connection-for-create>
                }

                <!-- connections -->
                @for (connection of connectionsSig(); track connection.id) {
                <f-connection [fReassignDisabled]="true"
                              [fConnectionId]="connection.id"
                              [fOutputId]="connection.from"
                              [fInputId]="connection.to"
                              fBehavior="floating"
                              fType="bezier">
                    <div fConnectionContent
                         [position]="0.5">
                        <span class="ui-icon-delete c-p delete-connection-btn"
                              (click)="deleteConnection(connection.id)">
                        </span>
                    </div>
                    <svg viewBox="0 0 6 7"
                         fMarker
                         [type]="eMarkerType.END"
                         class="connection-marker"
                         [height]="7"
                         [width]="6"
                         [refX]="5.5"
                         [refY]="3.5"
                         markerUnits="strokeWidth"
                         orient="auto">
                        <path d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z" />
                    </svg>
                    <svg viewBox="0 0 6 7"
                         fMarker
                         [type]="eMarkerType.SELECTED_END"
                         class="connection-marker"
                         [height]="7"
                         [width]="6"
                         [refX]="5.5"
                         [refY]="3.5"
                         markerUnits="strokeWidth"
                         orient="auto">
                        <path d="M0.000391006 0L6 3.5L0.000391006 7L0.000391006 0Z" />
                    </svg>
                </f-connection>
                }

                <!-- start node -->
                @if(graphModeSig() === graphModes.Preview && !stepNodesSig().length) {
                <div fNode
                     [fNodeId]="startNode.id"
                     [fNodePosition]="startNode.position">
                    <div class="flex-col center-center">
                        <p>{{'FLOW_CHART.START_BY_ADDING_TRIGGER'|translate}}</p>
                        <ui-button (clickAction)="drawer.open()"
                                   [text]="'FLOW_CHART.ADD_TRIGGER_BUTTON_TEXT'|translate"
                                   type="primary">
                        </ui-button>
                    </div>
                </div>
                }

                @for (sticker of stickersSig(); track sticker.id) {
                <div fNode
                     class="flow-sticker"
                     [fNodePosition]="sticker.position"
                     (fNodePositionChange)="nodePositionChange($event, sticker.id, true)"
                     [class.editing]="selectedStickerSig() === sticker.id"
                     fDragHandle
                     [fNodeDraggingDisabled]="graphModeSig() === graphModes.Publish"
                     [fNodeId]="sticker.id"
                     (dblclick)="startEditSticker(sticker, $event)">
                    <div class="sticker-content">
                        <span class="ui-icon-delete delete-btn c-p"
                              (click)="deleteSticker(sticker.id)">
                        </span>

                        <!-- VIEW MODE -->
                        @if (selectedStickerSig() !== sticker.id) {
                        <div class="sticker-text">
                            {{ sticker.text }}
                        </div>
                        }

                        <!-- EDIT MODE -->
                        @if (selectedStickerSig() === sticker.id) {
                        <textarea class="sticker-editor"
                                  [value]="sticker.text"
                                  (input)="onStickerTextChange(sticker.id, $event)"
                                  (blur)="finishEditSticker()"
                                  (keydown.enter)="finishEditSticker()"
                                  autofocus></textarea>
                        }
                    </div>
                </div>
                }

                <!-- nodes -->
                @for (node of stepNodesSig(); track node.id; let idx = $index) {
                <div fNode
                     class="flow-node"
                     [fNodePosition]="node.position"
                     (fNodePositionChange)="nodePositionChange($event, node.id)"
                     fDragHandle
                     [fNodeDraggingDisabled]="graphModeSig() === graphModes.Publish"
                     [fNodeId]="node.id"
                     (dblclick)="openNodeEditModal(node)">
                    <span class="hover-area"></span>
                    <span [class]="node.icon"
                          class="main-icon"></span>
                    @if(!getNodeIdFromGraph(node.id)) {
                    <span class="ui-icon-status-offline c-p invalid"
                          [matTooltip]="'FLOW_CHART.INVALID_NODE_TOOLTIP' | translate"
                          matTooltipClass="sidebar-tooltip">
                    </span>
                    }

                    @if(node.nodeType !== flowNodeTypes.Trigger) {
                    @for(input of node.inputs; track input.id) {
                    <div fNodeInput
                         fOutputConnectableSide="left"
                         class="left c-p"
                         [fInputId]="input.id"
                         [fInputMultiple]="true">
                    </div>
                    }
                    }

                    @for(output of node.outputs; track output.id; let idx = $index) {
                    <div fNodeOutput
                         fOutputConnectableSide="right"
                         class="right c-p"
                         [class.right-top]="idx === 0 && node.outputs.length > 1"
                         [class.right-bottom]="idx === 1 && node.outputs.length > 1"
                         [class.active]="selectedNodeSig()?.selectedOutputPort?.id === output.id"
                         (click)="openDrawerAndActionMenu(node, output, idx, $event)"
                         [fOutputId]="output.id"
                         [fOutputMultiple]="true">
                        @if (output.name) {
                        <div class="condition-name">{{output.name}}</div>
                        }
                        <span class="ui-icon-plus"></span>
                    </div>
                    }

                    <div uiTruncateText
                         class="node-name">
                        @if(node.data) {
                        {{node.data['name']}}
                        }@else {
                        {{node.name}}
                        }
                    </div>

                    @if(node.data && node.data['url'] && node.data['method']) {
                    <div uiTruncateText
                         class="hint"
                         [cdkCopyToClipboard]="node.data['url']"
                         (click)="showCopiedToast()">
                        {{node.data['method']}}
                        {{node.data['url']}}
                    </div>
                    }

                    <div class="node-menu">
                        <span class="ui-icon-more-menu node-icon c-p"
                              (click)="selectedNodeSig.set(node)"
                              [matMenuTriggerFor]="nodeActionMenu">
                        </span>
                    </div>

                    @if(node.nodeType === flowNodeTypes.Trigger) {
                    <div class="execute-btn-container">
                        <span class="ui-icon-play c-p"></span>
                        <ui-button (clickAction)="run(node.id)"
                                   type="primary"
                                   [disabled]="graphModeSig() === graphModes.Preview"
                                   [text]="'FLOW_CHART.EXECUTE_GRAPG'|translate">
                        </ui-button>
                        @if(graphModeSig() === graphModes.Preview) {
                        <span [matTooltip]="'FLOW_CHART.RUN_TOOLTIP' | translate"
                              matTooltipClass="sidebar-tooltip"
                              class="ui-icon-info c-p">
                        </span>
                        }
                    </div>
                    }
                </div>
                }
            </f-canvas>

            <div class="minimap-container">
                <f-minimap [fMinSize]="2000"></f-minimap>
            </div>
        </f-flow>
        @if(graphModeSig() === graphModes.Publish) {
        <div class="create-date-container">
            <ui-user-settings-date [date]="selectGraphSig()?.published?.publishedAt"></ui-user-settings-date>
        </div>
        }
    </div>
    }@else {
    <ui-preloader [color]="1">
    </ui-preloader>
    }

</mat-drawer-container>

<mat-menu #nodeActionMenu="matMenu"
          class="menu-no-padding">
    <button (click)="openSeletedNodeEditModal()"
            mat-menu-item>{{'COMMON.OPEN'|translate}}
    </button>
    <button (click)="copySeletedNode()"
            mat-menu-item>{{'COMMON.COPY_TOOLTIP'|translate}}
    </button>
    @if(graphModeSig() === graphModes.Preview) {
    <button (click)="deleteSelectedNode()"
            mat-menu-item>{{'COMMON.DELETE'|translate}}
    </button>
    }
</mat-menu>

<mat-menu #menu="matMenu"
          class="menu-no-padding">
    <button mat-menu-item
            (click)="downloadJson()">
        {{'COMMON.DOWNLOAD'|translate}}
    </button>
    @if(graphModeSig() === graphModes.Preview) {
    <button mat-menu-item
            (click)="fileInput.click()">
        {{'FLOW_CHART.IMPORT'|translate}}
    </button>

    <input type="file"
           accept="application/json"
           hidden
           #fileInput
           (change)="onImportFile($event)" />
    }

    <button mat-menu-item
            (click)="openEditWorkflowDialog()">
        {{'FLOW_CHART.SETTINGS'|translate}}
    </button>
</mat-menu>